var _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFacebookFillIcon = function SvgFacebookFillIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7314 17.6907C17.261 17.6907 17.6906 17.2611 17.6906 16.7313V1.26882C17.6906 0.738929 17.2611 0.309525 16.7314 0.309525H1.26887C0.738975 0.309525 0.30957 0.738929 0.30957 1.26882V16.7313C0.30957 17.2611 0.738908 17.6907 1.26887 17.6907H16.7314Z",
    fill: "#3C5A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3019 17.6908V10.9599H14.5612L14.8995 8.33674H12.3019V6.66201C12.3019 5.90254 12.5128 5.38499 13.6019 5.38499L14.9909 5.38438V3.0382C14.7507 3.00624 13.9261 2.93481 12.9668 2.93481C10.9641 2.93481 9.59305 4.15727 9.59305 6.40222V8.33674H7.328V10.9599H9.59305V17.6908H12.3019Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9999,
    height: 18,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebookFillIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook-fill-icon.4cf32059.svg";
export { ForwardRef as ReactComponent };